// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__26lBt","title":"Header_title__1UmWp","left":"Header_left__2yw--","clinicName":"Header_clinicName__2aqW5"};